<template>
    <div class="admin-dashboard">
        <h1 class="page-title">{{ group }} Dashboard</h1>
        <div class="md-layout md-gutter chart-wrapper">
            <component :key="key" v-for="(graph, key) in graphs" :is="key" />
        </div>
    </div>
</template>

<script>
  import RecentAccessTotal from "./charts/RecentAccessTotal";
  import RecentAccessLearner from "./charts/RecentAccessLearner";
  import GroupEngagement from "./charts/GroupEngagement";
  import SubGroupEngagement from "./charts/SubGroupEngagement";
  import LearnersEngagementStrategy from "./charts/LearnersEngagementStrategy";
  import LearnersEngagement from "./charts/LearnersEngagement";
  import MostPopularStrategies from "./charts/MostPopularStrategies";
  import ReadySetGo from "./charts/ReadySetGo";
  import TopRatedStrategies from "./charts/TopRatedStrategies";
  import CoachEngagement from "./charts/CoachEngagement";
  import CoachCompletedObservations from "./charts/CoachCompletedObservations";

  export default {
    name: "AdminDashboard",
    components: {
      RecentAccessTotal,
      RecentAccessLearner,
      GroupEngagement,
      SubGroupEngagement,
      LearnersEngagementStrategy,
      LearnersEngagement,
      ReadySetGo,
      TopRatedStrategies,
      CoachEngagement,
      MostPopularStrategies,
      CoachCompletedObservations,
    },
    computed: {},
    mounted() {},
    data() {
      return {
        isGroupAdmin: window.drupalSettings.controller.groupAdmin,
        group: window.drupalSettings.user.group,
        graphs: drupalSettings.controller.graphs || []
      };
    },
    methods: {}
  };
</script>
<style lang="scss">
    .md-app-content {
        .admin-dashboard {
            h1.page-title {
                color: $title-blue;
                font-family: $font-filson-soft;
                font-size: 36px !important;
                line-height: 54px;
                margin-top: 0px;
            }
            .fb-welcome {
                display: none;
            }
        }
    }

    .chart-wrapper {
        > div:last-child {
            max-width: 100%;
            flex: 1;
        }
        justify-content: left;
        align-items: stretch;
        .chart {
            padding-bottom: 12px;
            padding-right: 12px !important;
            padding-left: 12px !important;
            margin-bottom: 12px;
            @media only screen and (max-width: 1024px)  {
                width: 100% !important;
                min-width: 100% !important;
                max-width: 100% !important;
            }

            > div {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 16px;
                padding-bottom: 0px;
                background: #ffffff;
                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
                border-radius: 20px;
                min-height: 100%;
                h2 {
                    font-size: 20px;
                    font-family: $font-filson-soft;
                    margin: 0px;
                    font-weight: 600;
                }
                .description {
                    text-align: center;
                }
            }

            .apexcharts-tooltip.apexcharts-active {
                margin-left: 30px;
            }

        }
        .chart.engagement {
            > div {
                background: #ffffff;
            }
        }

    }
</style>
